import { Box, createStyles, InputLabel, makeStyles, Theme } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import React, { useState } from 'react';

import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';

export enum DiscreteRangeEnum {
  MinusInfinity = 0,
  GreaterOrEqual = 1,
  Greater = 2,
  Equal = 3, // if equal set 'from' and 'to' values same
  Lower = 4,
  LowerOrEqual = 5,
  PlusInfinity = 6,
}

interface OwnProps {
  label?: string;
  onChange: (value: DiscreteRangeEnum[]) => void;
  defaultValue: number[];
}

const InputDiscreteRangeSlider: React.FC<OwnProps> = ({ onChange, label, defaultValue = [] }) => {
  const classes = useStyles();
  const [state, setState] = useState<number[]>(defaultValue);

  useDefaultValueWatcher({ defaultValue, state, setState });

  return (
    <Box className={classes.sliderBox}>
      <InputLabel>{label}</InputLabel>
      <Slider
        value={state}
        aria-labelledby="discrete-slider-custom"
        step={1}
        max={6}
        marks={DISCRETE_RANGE_MARKS}
        className={classes.root}
        onChange={(_: any, newValue: number[] | number) =>
          setState(newValue as DiscreteRangeEnum[])
        }
        onChangeCommitted={(_: any, newValue: number[] | number) =>
          onChange(newValue as DiscreteRangeEnum[])
        }
      />
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.divider,
      height: 3,
      padding: '13px 0',
    },
    sliderBox: {
      paddingLeft: '8px',
      paddingRight: '4px',
    },
  }),
);

export const DISCRETE_RANGE_MARKS = [
  {
    value: DiscreteRangeEnum.MinusInfinity,
    label: '-∞',
  },
  {
    value: DiscreteRangeEnum.GreaterOrEqual,
    label: '≥',
  },
  {
    value: DiscreteRangeEnum.Greater,
    label: '>',
  },
  {
    value: DiscreteRangeEnum.Equal,
    label: '=',
  },
  {
    value: DiscreteRangeEnum.Lower,
    label: '<',
  },
  {
    value: DiscreteRangeEnum.LowerOrEqual,
    label: '≤',
  },
  {
    value: DiscreteRangeEnum.PlusInfinity,
    label: '∞',
  },
];

export default InputDiscreteRangeSlider;
